export function allowUnlistedDenominationsFromOfferRates(vendor = '') {
  const checkForBypassVendors = ['CitadelTools', 'CitadelTools_Fluz_Warehouse', 'CitadelTools_Resale_Warehouse'];
  return checkForBypassVendors.includes(vendor);
}
